import { ReactNode, useContext } from 'react';
import { InputWrapperContext } from '@mantine/core';
import { joinIds } from '../context/FieldA11yContext';

/**
 * Поле Mantine (`Input` с `withAria`, поле `PasswordInput`) ставит `aria-describedby` из контекста своей обёртки
 * поверх переданного пропом, поэтому id группы добавляются в этот контекст: перед описанием Mantine (счётчик символов).
 */
const MantineDescribedBy = ({ ids, children }: { ids?: string; children?: ReactNode }) => {
    const wrapper = useContext(InputWrapperContext);
    return (
        <InputWrapperContext value={{ ...wrapper, describedBy: joinIds(ids, wrapper.describedBy) }}>
            {children}
        </InputWrapperContext>
    );
};

export default MantineDescribedBy;
